export const MAX_PREVIEW_IMAGES = 50;
// to be higher than pendo guide (300000)
export const UPLOAD_DIALOG_Z_INDEX = 300001;
